import { Button, Form, InputNumber, Switch, notification } from "antd";
import { useContext, useEffect, useState } from "react";

import "../styles.css";

import { Context } from "../../../context";
import { Fetch, Put } from "../../../fetch";

const UnlockConfig = () => {
  const { token, apiUrl } = useContext(Context);

  const [saving, setSaving] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    Fetch(`${apiUrl}/v4/tasks-config/config/unlock_config`, token, (result) => {
      if (result && result.success !== false) {
        const data = result.data || {};
        form.setFieldsValue({
          enabled: data.enabled ?? false,
          defaultValidityDays: data.defaultValidityDays ?? 30,
          defaultSeriesCoinPrice: data.defaultSeriesCoinPrice ?? 500,
          defaultBundleCoinPrice: data.defaultBundleCoinPrice ?? 150,
          defaultBundleSize: data.defaultBundleSize ?? 5,
        });
      }
    });
  }, [apiUrl, token, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      Put(
        `${apiUrl}/v4/tasks-config/config/unlock_config`,
        token,
        {
          data: {
            enabled: values.enabled ?? false,
            defaultValidityDays: values.defaultValidityDays,
            defaultSeriesCoinPrice: values.defaultSeriesCoinPrice,
            defaultBundleCoinPrice: values.defaultBundleCoinPrice,
            defaultBundleSize: values.defaultBundleSize,
          },
        },
        (result) => {
          setSaving(false);
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Unlock config updated",
            });
          } else {
            notification.error({
              message: "Error updating unlock config",
              description: "Check console for more details",
            });
          }
        },
        () => {
          setSaving(false);
          notification.error({
            message: "Error updating unlock config",
            description: "Check console for more details",
          });
        }
      );
    } catch (err) {
      notification.error({
        message: "Error updating unlock config",
        description: "Fields are incorrect/missing",
      });
    }
  };

  return (
    <div className="manage-tasks-wrapper">
      <Form
        form={form}
        layout="vertical"
        className="manage-tasks-config-form"
        initialValues={{
          enabled: false,
          defaultValidityDays: 30,
          defaultSeriesCoinPrice: 500,
          defaultBundleCoinPrice: 150,
          defaultBundleSize: 5,
        }}
      >
        <Form.Item name="enabled" label="Enabled" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          name="defaultValidityDays"
          label="Default validity (days)"
          extra="How long a coin unlock lasts when the series has no explicit validity"
          rules={[
            { required: true, message: "Default validity is required" },
            {
              type: "integer",
              min: 1,
              message: "Default validity must be an integer >= 1",
            },
          ]}
        >
          <InputNumber min={1} precision={0} placeholder="Enter days" />
        </Form.Item>
        <Form.Item
          name="defaultSeriesCoinPrice"
          label="Default full series price (coins)"
          extra="Applies when a series has no explicit full-series price (default 500)"
          rules={[
            { required: true, message: "Default full series price is required" },
            {
              type: "integer",
              min: 0,
              message: "Default full series price must be an integer >= 0",
            },
          ]}
        >
          <InputNumber min={0} precision={0} placeholder="Enter coins" />
        </Form.Item>
        <Form.Item
          name="defaultBundleCoinPrice"
          label="Default bundle price (coins)"
          extra="Applies when a series has no explicit bundle price (default 150)"
          rules={[
            { required: true, message: "Default bundle price is required" },
            {
              type: "integer",
              min: 0,
              message: "Default bundle price must be an integer >= 0",
            },
          ]}
        >
          <InputNumber min={0} precision={0} placeholder="Enter coins" />
        </Form.Item>
        <Form.Item
          name="defaultBundleSize"
          label="Default bundle episodes"
          extra="Episodes per bundle when a series has no explicit bundle size (default 5)"
          rules={[
            { required: true, message: "Default bundle episodes is required" },
            {
              type: "integer",
              min: 1,
              message: "Default bundle episodes must be an integer >= 1",
            },
          ]}
        >
          <InputNumber min={1} precision={0} placeholder="Enter episodes" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleSubmit} loading={saving}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UnlockConfig;
